import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    vehicleTypes: [],
    //FORM PAGES VALUES
    listView: true,
    filterBy: "",
    loadingVehicleTypes: false,

  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', "")
      context.commit('modifyVehicle', "")
      context.commit('modifyVehicle', "")
      context.commit('modifySite', "")
      context.commit('resetTrips')
    },
    reset(context) {

    }
  },
  getters: {
    getVehicles: state => state.vehicles
  }
}